export const api = {
  requestPasswordResetURL: '/auth/password/request',
  loginURL: '/auth/login',
  logoutURL: '/auth/logout',
  loginOktaURL: '/auth/login/okta',
  resetPasswordURL: '/auth/password/reset',
  validateTokenURL: '/auth/token/validate',
  checkAuthProviderURL: '/auth/provider',
  impersonateURL: '/auth/impersonate',
  sessionURL: '/auth/session',

  contactsURL: '/contacts',
  loggedInContactURL: '/contacts/me',
  oktaContactURL: '/contacts/okta',
  usersURL: '/users',
  oktaUsersURL: '/okta-users',
  onboardOktaUsersURL: '/okta-users/onboard',
  changeOktaPasswordURL: '/okta-users/me/change-password',
  oktaMigrationURL: '/okta-users/migrate',

  attachmentURL: '/attachments',
  invoiceAttachmentURL: '/attachments/invoices',
  sofAttachmentURL: '/attachments/sof',

  lineItemsURL: '/line-items',
  ordersURL: '/orders',
  ordersV2URL: '/ordersv2',
  servicesURL: '/services',

  taskAssignmentsURL: '/task-assignments',
  tasksURL: '/tasks',

  invoicesURL: '/invoices',
  paymentsURL: '/payments',

  nodesDownURL: '/nodes/down',

  commentsURL: '/comments',
  ticketsURL: '/tickets',

  banLookupsURL: '/ban-lookups',
  locationsURL: '/locations',
  portalRolesURL: '/portal-roles',

  getQOELeadsURL: '/qoe/leads',
  getQOEAggregates: '/qoe/aggregate',

  ticketSummaryURL: '/iq/tickets/summary',
  getUnusualMetrics: '/anomalies/unusual-metrics',
  getMetricDetails: '/insights/metrics/details',
  getAggregatedMetrics: '/insights/metrics/aggregate',
  getAnomaliedLeadsAggregate: '/anomalies/leads/aggregate',
  getAnomaliedLeads: '/anomalies/leads',

  getDeviceLocationsURL: '/iq/device-locations',
  surveyURL: `/surveys`,
  getUnmDeviceEventsURL: '/insights/metrics/unm-device-events',
  getObservationsSummary: '/insights/metrics/summary',
  getHistoricalObservationsURL: '/insights/metrics/historical-observations',
  getHistoricalObservationsByNIT: '/insights/metrics/historical-observations',
  get95PUtilizationURL: '/insights/metrics/95p-utilization',
};
